/** Журнал собственной кассы — служба Receipts. */
const ROOT = '/api/receipts/v1'
const resource = (rid: string) => `${ROOT}/resources/${encodeURIComponent(rid)}`
export const OWN_JOURNAL_URLS = {
  detail: (rid: string, id: string) => `${resource(rid)}/receipts/${encodeURIComponent(id)}`,
} as const
